module.exports = __webpack_public_path__ + "static/sample-22-a170d3d3b80553c607415c1acdf6f82f.png";